
var validator = require('validator');
var stringUtil = require('../string/stringUtil.js');
const localizationUtils = require('../localization/localizationUtils');

module.exports.isNumeric = function(value)
{
    value = value + "";
    if (stringUtil.isStringNullOrEmpty(value))
        return false;

    var options = {};
    options.force_decimal = false;
    return validator.default.isFloat(value, options)
}

module.exports.isGreaterThanOrEqualToZero = function(value)
{
    return this.isNumeric(value) && Number(value) >= 0;
}

module.exports.isInteger = function(value)
{
    value = value + "";
    if (stringUtil.isStringNullOrEmpty(value))
        return false;

    return validator.default.isInt(value)
}

module.exports.isValidEmailAddress = function (emailAddress)
{
    if (stringUtil.isStringNullOrEmpty(emailAddress))
        return false;

    return validator.default.isEmail(emailAddress);
}

module.exports.isValidPhoneNumber = function (phoneNumber)
{
    const phoneNumberRegex = localizationUtils.getPhoneNumberValidator();
    
    if (stringUtil.isStringNullOrEmpty(phoneNumber))
        return false;

    phoneNumber = stringUtil.trimString(phoneNumber);

    return phoneNumber.match(phoneNumberRegex);
}